import { registerKeapFormElement } from './keap-forms-processing';
import { registerKeapEventElements, registerKeapHostingElement } from '@/hosting/keap-track';
import { processKeapLinks } from '@/hosting/keap-links';
import { processCalendly } from '@/hosting/calendly-appointments';

(function () {
    registerKeapHostingElement();
    registerKeapFormElement();
    registerKeapEventElements();
    processKeapLinks();
    processCalendly();
}());

